import { Suspense } from 'react';

import { Group, Skeleton, Text } from '@mantine/core';

import { useTranslation } from 'react-i18next';

import { Button } from '../../../../../../../shared/components/UI/Button/Button';

import { TextSeparator } from '../../../../../../../shared/components/TextSeparator';
import { useGetAllResponseProject } from '../../../hooks/useGetAllResponseProject.hooks';

interface ResponseProjectPageTitleProps {
  onCreateProject?: () => void;
}

export function ResponseProjectPageTitle(props: ResponseProjectPageTitleProps) {
  return (
    <Suspense fallback={<Loading />}>
      <SafeResponseProjectListPageTitle {...props} />
    </Suspense>
  );
}

function Loading() {
  return (
    <Group noWrap spacing="01">
      <Skeleton h={15} w={150} />
      <Skeleton h={15} w={180} />
    </Group>
  );
}

function SafeResponseProjectListPageTitle({
  onCreateProject,
}: ResponseProjectPageTitleProps) {
  const { t } = useTranslation('bidResponse');
  const { data } = useGetAllResponseProject();

  return (
    <Group noWrap spacing="01" align="center" position="apart">
      <Group noWrap spacing="01">
        <Text size="md" c="gray.9" fw={500}>
          {t('project.title')}
        </Text>
        <TextSeparator />
        <Text variant="sm" fw={400} c="gray.6">
          {t('project.projectsCount', {
            count: data.projects?.length ?? 0,
          })}
        </Text>
      </Group>
      {!!onCreateProject && (
        <Button onClick={onCreateProject}>
          {t('project.createOrEditProject.createTrigger')}
        </Button>
      )}
    </Group>
  );
}
